// Staging/Development Settings
let estimatedDeliveryURL =
  'https://1dfsx2nwel.execute-api.us-east-1.amazonaws.com/dev/';
let estimatedDeliveryKey = '4gSzevX1zzaq62FhdtQJF714c35Ke5L63qaQvjwK';
let rebuyCheckout = '74230';
let rebuyMinicart = '105153';
let rebuyPairWith = '104550';
let rebuyReccomendation = '74234';
let rebuyProductReccomendation = '74247';
let storeMapperID = '19309-aU3Ck9bMrLXzijLm';
const sentryDSN =
  'https://2a7eafb85e354501b554302d25766758@o5438.ingest.sentry.io/4505330197659648';
let sentryEnvironment = 'development';
const sentryTargets = [
  'localhost',
  /^https:\/\/shopserta-development.myshopify\.com\//,
  /^https:\/\/shopserta.myshopify\.com\//,
];
// Blueshift values are the same for prod and staging
let blueshiftURL =
  'https://07qnp9c8kc.execute-api.us-east-1.amazonaws.com/production/sr-blue-shift';
let blueshiftKey = 'MpwXKpR5S57ZpKym1JVPb8BEbxzzPvJl4lgCJcs3';

// Production Settings
if (window.location.hostname === 'www.serta.com') {
  estimatedDeliveryURL =
    'https://isi1tc79ee.execute-api.us-east-1.amazonaws.com/production/';
  estimatedDeliveryKey = 'MpwXKpR5S57ZpKym1JVPb8BEbxzzPvJl4lgCJcs3';
  rebuyCheckout = '62866';
  rebuyMinicart = '105164';
  rebuyPairWith = '105160';
  rebuyReccomendation = '62860';
  rebuyProductReccomendation = '62606';
  storeMapperID = '18446-O4DbuJKXzCSwtnpa';
  sentryEnvironment = 'production';
  blueshiftURL =
    'https://07qnp9c8kc.execute-api.us-east-1.amazonaws.com/production/sr-blue-shift';
  blueshiftKey = 'MpwXKpR5S57ZpKym1JVPb8BEbxzzPvJl4lgCJcs3';
}

const env = {
  BLUESHIFT_KEY: blueshiftKey,
  BLUESHIFT_URL: blueshiftURL,
  ESTIMATED_DELIVERY_KEY: estimatedDeliveryKey,
  ESTIMATED_DELIVERY_URL: estimatedDeliveryURL,
  REBUY_CHECKOUT: rebuyCheckout,
  REBUY_MINICART: rebuyMinicart,
  REBUY_PAIR_WITH: rebuyPairWith,
  REBUY_PRODUCT_RECCOMENDATION: rebuyProductReccomendation,
  REBUY_RECCOMENDATION: rebuyReccomendation,
  SENTRY_DSN: sentryDSN,
  SENTRY_ENVIRONMENT: sentryEnvironment,
  SENTRY_TARGETS: sentryTargets,
  STORE_MAPPER_ID: storeMapperID,
};

export default env;
